module.exports = __webpack_public_path__ + "img/hic-neoplasm-male.e53b66cc.png";